import React from "react";

const SignInModal = ({ onClose, onSwitchToSignUp }) => {
    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
            <div className="w-full max-w-[520px] bg-[#FAFAF9] rounded-2xl border border-gray-200 shadow-xl">

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-gray-900">Sign in</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-6 space-y-5">
                    <p className="text-sm text-gray-500">
                        Access your dashboard to manage invoice discounting.
                    </p>

                    {/* Email */}
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Work email</label>
                        <input
                            type="email"
                            placeholder="you@company.com"
                            className="w-full h-11 rounded-lg border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                        />
                    </div>

                    {/* Password */}
                    <div>
                        <label className="block text-sm text-gray-600 mb-1">Password</label>
                        <input
                            type="password"
                            placeholder="••••••••"
                            className="w-full h-11 rounded-lg border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                        />
                        <a href="#" className="text-xs text-gray-500 underline mt-2 inline-block">
                            Forgot password?
                        </a>
                    </div>

                    {/* SSO Buttons */}
                    <div className="space-y-3">
                        <button className="w-full h-11 rounded-lg border border-gray-300 text-sm font-medium">
                            Magic link to email
                        </button>
                        <button className="w-full h-11 rounded-lg border border-gray-300 text-sm font-medium">
                            Continue with Google
                        </button>
                        <button className="w-full h-11 rounded-lg border border-gray-300 text-sm font-medium">
                            Continue with GitHub
                        </button>
                    </div>

                    {/* ✅ Switch to Sign Up */}
                    <p className="text-sm text-gray-600 text-center">
                        Don't have an account?{" "}
                        <button
                            onClick={onSwitchToSignUp}
                            className="text-[#00B39F] font-medium hover:underline"
                        >
                            Create one
                        </button>
                    </p>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between px-6 py-5 border-t border-gray-200">
                    <button className="h-10 px-4 rounded-lg border border-gray-300 text-sm">
                        Use SSO
                    </button>
                    <button className="h-10 px-5 rounded-lg bg-[#00B39F] text-white text-sm font-medium">
                        Sign in
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignInModal;